import styled from "styled-components";

export const Container = styled.div`
  padding: 95px 20px;
  float: left;
  width: 100%;
  position: relative;
`;

export const HomeFornada = styled.form`
  .cadastros {
    float: left;
    width: 100%;
    padding: 1%;
    position: relative;
  }

  .cadastros h1 {
    font-size: 25px;
    font-weight: 300;
    text-align: center;
    line-height: 35px;
    color: #565656;
  }

  .sml {
    margin: -21px 0 0 0;
    float: left;
    width: 100%;
    font-size: 11px;
  }

  .cadastros h1 span {
    display: block;
    font-weight: 900;
  }

  #filtros {
    float: left;
    width: 100%;
    padding: 1%;
    position: relative;
  }

  .selects {
    border: 1px solid #ced4da;
    width: 100%;
    appearance: none;
    border-radius: 0.25rem;
    float: left;
    padding: 10px 20px;
    height: 100px;
    overflow: auto;
  }

  .notedit {
    float: left;
    width: 100%;
    border: 1px #f32b00 solid;
    border-radius: 0.25rem;
    padding: 1rem;
    margin: 1% 0;

    h1 {
      font-weight: 600;
      font-weight: 600;
      padding: 0 !important;
      margin: 1% 0;
      color: #f32b00;
    }
  }

  .btnfor {
    position: absolute;
    bottom: 5%;
    right: 1%;
  }

  .exe {
    color: #388e3c;
    border: 1px #388e3c solid;
    padding: 5px 20px;
    border-radius: 0.25rem;
    float: right;
    font-size: 12px;
    font-weight: 700;
    transition: 0.5s;

    &:hover {
      background: #388e3c;
      color: #fff;
      transition: 0.5s;
    }
  }

  .campos20,
  .campos30,
  .campos40,
  .campos50,
  .campos60,
  .campos100 {
    float: left;
    padding: 10px;
    position: relative;
  }

  .campos20 {
    width: 20%;
  }

  .campos30 {
    width: 30%;
  }
  .campos40 {
    width: 40%;
  }
  .campos50 {
    width: 50%;
  }
  .campos60 {
    width: 60%;
  }

  .campos100 {
    width: 100%;
  }

  #marta1,
  #marta2,
  #marta3 {
    display: none;
  }

  .visivel {
    display: block !important;
  }

  #resultado {
    float: left;
    width: 100%;
    padding: 0 2%;
    border: 1px #ddd solid;
    border-radius: 5px;
  }

  .tabresp {
    float: left;
    width: 100%;
  }

  #infos {
    float: left;
    width: 100%;
    padding: 2% 0;
  }

  #infos section {
    float: left;
    width: 14.2%;
    text-align: center;
    font-size: 15px;
  }

  #infos section p {
    padding: 0 20px;
  }

  #infos section strong {
    color: #333;
    font-weight: 900;
    font-size: 30px;
    display: block;
  }

  .oft small {
    display: block;
    font-size: 11px;
    padding: 0;
  }

  .linha {
    width: 100%;
  }

  @media only screen and (max-width: 1366px) {
  }

  @media only screen and (max-width: 1024px) {
  }
  @media only screen and (max-width: 801px) {
    .campos20,
    .campos30,
    .campos40,
    .campos50,
    .campos60,
    .campos100 {
      width: 100%;
    }

    .tabresp {
      overflow-x: auto;
    }

    #infos section {
      width: 25%;
    }
  }
  @media only screen and (max-width: 668px) {
  }
  @media only screen and (max-width: 480px) {
    #infos section {
      width: 33%;
    }
  }
`;
